export default function WeekendCourses() {
  window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <>
      <>
        <section className="hero" style={{ padding: "4.5rem 0 3.5rem" }}>
          <div className="dot-grid-layer" />
          <div className="container text-center">
            <span className="kicker justify-content-center">
              🔥 Weekend batch open
            </span>
            <h1 className="mt-3">
              Stock Market Crash Course
              <br />
              <em>Master Trading in 1 Month</em>
            </h1>
            <p className="lead mx-auto">
              Perfect for working professionals &amp; busy learners — 8
              sessions, Saturdays &amp; Sundays, 6–8 PM, online &amp; offline.
            </p>
            <div
              className="d-flex justify-content-center align-items-baseline mt-4"
              style={{ gap: "1rem" }}
            >
              <span
                className="text-mono"
                style={{
                  textDecoration: "line-through",
                  color: "#8B93C4",
                  fontSize: "1.3rem",
                }}
              >
                ₹15,000
              </span>
              <span
                style={{
                  fontFamily: '"Sora",sans-serif',
                  fontWeight: 800,
                  fontSize: "3rem",
                  color: "#F59E0B",
                }}
              >
                ₹9,999
              </span>
            </div>
            <p className="text-mono small" style={{ color: "#B9C0F0" }}>
              Limited time offer
            </p>
            <a
              href="https://wa.me/7004654910?text=Hi%2C%20I%20saw%20your%20website%2C%20I%27m%20interested%20in%20the%20Weekend%20Crash%20Course.%20Could%20you%20share%20more%20details%3F"
              className="btn btn-brass btn-lg mt-2"
              target="_blank"
              rel="noopener"
            >
              Enroll Now for ₹9,999
            </a>
          </div>
        </section>
        <section className="section">
          <div className="container">
            <div className="section-head mx-auto text-center">
              <span className="kicker justify-content-center">
                Course overview
              </span>
              <h2>L2E Crash Course Details</h2>
            </div>
            <div className="row text-center">
              <div className="col-md-4 mb-4">
                <div
                  className="feature-item"
                  style={{
                    border: 0,
                    flexDirection: "column",
                    textAlign: "center",
                  }}
                >
                  <div className="feature-icon mx-auto mb-2">📅</div>
                  <h4>8 Powerful Sessions</h4>
                  <p>Saturdays &amp; Sundays, 4 weekends total</p>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div
                  className="feature-item"
                  style={{
                    border: 0,
                    flexDirection: "column",
                    textAlign: "center",
                  }}
                >
                  <div className="feature-icon mx-auto mb-2">⏰</div>
                  <h4>2 Hours Daily</h4>
                  <p>6:00–8:00 PM, built for working professionals</p>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div
                  className="feature-item"
                  style={{
                    border: 0,
                    flexDirection: "column",
                    textAlign: "center",
                  }}
                >
                  <div className="feature-icon mx-auto mb-2">💻</div>
                  <h4>Online &amp; Offline</h4>
                  <p>Choose your mode, flexibility to switch</p>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div
                  className="feature-item"
                  style={{
                    border: 0,
                    flexDirection: "column",
                    textAlign: "center",
                  }}
                >
                  <div className="feature-icon mx-auto mb-2">📚</div>
                  <h4>5 Core Modules</h4>
                  <p>Structured curriculum, beginner to confident trader</p>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div
                  className="feature-item"
                  style={{
                    border: 0,
                    flexDirection: "column",
                    textAlign: "center",
                  }}
                >
                  <div className="feature-icon mx-auto mb-2">🗣️</div>
                  <h4>Hindi &amp; English</h4>
                  <p>Bilingual teaching, easy to follow</p>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div
                  className="feature-item"
                  style={{
                    border: 0,
                    flexDirection: "column",
                    textAlign: "center",
                  }}
                >
                  <div className="feature-icon mx-auto mb-2">🎓</div>
                  <h4>10+ Years Faculty</h4>
                  <p>Learn from experienced market trainers</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section bg-paper">
          <div className="container">
            <div className="section-head mx-auto text-center">
              <span className="kicker justify-content-center">Curriculum</span>
              <h2>5 Learning Modules</h2>
            </div>
            <ul className="mod-list">
              <li>
                <span className="mod-num">01</span>
                <div>
                  <h5>Market Fundamentals</h5>
                  <p>
                    Stock market basics, terminologies, participants and trading
                    sessions.
                  </p>
                </div>
              </li>
              <li>
                <span className="mod-num">02</span>
                <div>
                  <h5>Technical Analysis Foundations</h5>
                  <p>
                    Charts, candlesticks, support &amp; resistance, trendlines
                    and pattern recognition.
                  </p>
                </div>
              </li>
              <li>
                <span className="mod-num">03</span>
                <div>
                  <h5>Price Action &amp; Indicators</h5>
                  <p>
                    Reading price movement with RSI, MACD and moving averages.
                  </p>
                </div>
              </li>
              <li>
                <span className="mod-num">04</span>
                <div>
                  <h5>Entry-Exit &amp; Risk Management</h5>
                  <p>
                    High-probability entries, stop-loss placement, position
                    sizing.
                  </p>
                </div>
              </li>
              <li>
                <span className="mod-num">05</span>
                <div>
                  <h5>Old Charts Trading Practice</h5>
                  <p>Real market analysis and guided practice with mentors.</p>
                </div>
              </li>
            </ul>
          </div>
        </section>
        <section className="section">
          <div className="container">
            <div className="section-head mx-auto text-center">
              <span className="kicker justify-content-center">Perfect for</span>
              <h2>Who Should Join This Course?</h2>
            </div>
            <div className="row text-center">
              <div className="col-6 col-md-3 mb-3">
                <div className="feature-icon mx-auto mb-2">💼</div>
                <p className="small mb-0">Working Professionals</p>
              </div>
              <div className="col-6 col-md-3 mb-3">
                <div className="feature-icon mx-auto mb-2">👔</div>
                <p className="small mb-0">Job Holders</p>
              </div>
              <div className="col-6 col-md-3 mb-3">
                <div className="feature-icon mx-auto mb-2">🏢</div>
                <p className="small mb-0">Business Owners</p>
              </div>
              <div className="col-6 col-md-3 mb-3">
                <div className="feature-icon mx-auto mb-2">🎯</div>
                <p className="small mb-0">Beginners in Trading</p>
              </div>
            </div>
          </div>
        </section>
        <section className="section bg-paper" id="enroll-form">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-7">
                <div className="form-panel">
                  <h3 className="text-center mb-1">Secure Your Seat</h3>
                  <p className="text-center text-muted-soft small mb-4">
                    Limited seats available for this weekend batch
                  </p>
                  <form className="form-panel-25">
                    <div className="form-row">
                      <div className="col-md-6 form-group">
                        <label>Full Name *</label>
                        <input className="form-control" required="" />
                      </div>
                      <div className="col-md-6 form-group">
                        <label>Phone Number *</label>
                        <input className="form-control" required="" />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6 form-group">
                        <label>Email Address *</label>
                        <input
                          type="email"
                          className="form-control"
                          required=""
                        />
                      </div>
                      <div className="col-md-6 form-group">
                        <label>City / Town *</label>
                        <input className="form-control" required="" />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6 form-group">
                        <label>Your Experience Level *</label>
                        <select className="form-control" required="">
                          <option value="">Select your level</option>
                          <option>Complete Beginner</option>
                          <option>Learner / Beginner Trader</option>
                          <option>Struggling Trader</option>
                          <option>Active Trader</option>
                        </select>
                      </div>
                      <div className="col-md-6 form-group">
                        <label>Preferred Mode *</label>
                        <select className="form-control" required="">
                          <option value="">Select mode</option>
                          <option>Online Classes</option>
                          <option>Offline Classes ()</option>
                          <option>Both</option>
                        </select>
                      </div>
                    </div>
                    <button
                      className="btn btn-brass btn-block btn-lg mt-2"
                      type="submit"
                    >
                      Enroll in Crash Course — ₹9,999
                    </button>
                    <p className="text-center small text-muted-soft mt-3 mb-0">
                      By enrolling, you agree to receive course updates from
                      Learning 2 Earning Academy.
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    </>
  );
}
